module.exports = __webpack_public_path__ + "img/speaker-ClarenceSeedorf-video.8d333917.png";